import request from '@/utils/request';
import { getCookie } from '@/utils/cookie';

const STORE_SERVICE_URL =
  '/api/v2/apps/system/store_service/save_info';
const STORE_SERVICE_BT = 'SBS';
const STORE_SERVICE_SBT = 'WMSV2';

export interface StoreTemplate {
  template_id: string;
  data: string;
  template_name: string;
  ctime: number;
}

function getUserEmail() {
  return getCookie('wms_display_name') || '';
}

function getStation() {
  return getCookie('setting_whs_v2') || '';
}

function getUrlPath() {
  return window.location.host + window.location.pathname + window.location.hash;
}

export async function createTemplate(
  data: string,
  keyName: string,
  templateName: string
) {
  const userEmail = getUserEmail();
  if (!userEmail) return;

  await request.post(`${STORE_SERVICE_URL}/create`, {
    user_email: userEmail,
    type: 1,
    bt: STORE_SERVICE_BT,
    sbt: STORE_SERVICE_SBT,
    data,
    url_path: getUrlPath(),
    key_name: keyName,
    template_name: templateName,
    station: getStation(),
  });
}

export async function getTemplateList(
  keyName: string
): Promise<StoreTemplate[]> {
  const userEmail = getUserEmail();
  if (!userEmail) return [];

  const response = await request.get(`${STORE_SERVICE_URL}/search`, {
    params: {
      user_email: userEmail,
      type: 1,
      bt: STORE_SERVICE_BT,
      sbt: STORE_SERVICE_SBT,
      url_path: getUrlPath(),
      key_name: keyName,
      station: getStation(),
    },
  });
  return response?.data?.list || [];
}

export async function updateTemplate(templateID: string, data: string) {
  await request.post(`${STORE_SERVICE_URL}/update`, {
    data,
    template_id: templateID,
  });
}

export async function recentlyUsed(templateID: string) {
  await request.get(`${STORE_SERVICE_URL}/recently_used`, {
    params: {
      template_id: templateID,
    },
  });
}
